import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { EpisodeDetailsForm } from "~/components/views/app/episode/details-form";
import { getEpisodeTypeOptions } from "~/models/episode";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute("/_app/podcasts/$channelUid/episodes/$episodeUid/details")({
	component: Page,
	async loader({ context }) {
		context.queryClient.prefetchQuery(context.trpc.parameter.languages.queryOptions());
	},
});

function Page() {
	const { channelUid, episodeUid } = Route.useParams();
	const trpc = useTRPC();

	const channelQuery = useSuspenseQuery(
		trpc.channel.find.queryOptions({
			channelUid,
		}),
	);
	const languagesQuery = useSuspenseQuery(trpc.parameter.languages.queryOptions());
	const episodeQuery = useSuspenseQuery(trpc.episode.find.queryOptions({ episodeUid }));

	return (
		<EpisodeDetailsForm
			channel={channelQuery.data}
			episode={episodeQuery.data}
			episodeTypes={getEpisodeTypeOptions()}
			languages={languagesQuery.data.map((language) => ({
				value: language.isO2,
				label: `${language.name} - ${language.localName}`,
				search: `${language.name} - ${language.localName}`,
			}))}
		/>
	);
}
